import { render, staticRenderFns } from "./GiftRegistrationNoteModal.vue?vue&type=template&id=097bcd4a&scoped=true&"
import script from "./GiftRegistrationNoteModal.vue?vue&type=script&lang=js&"
export * from "./GiftRegistrationNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097bcd4a",
  null
  
)

export default component.exports